<ig-page-not-found [lastUrl]="lastUrl"></ig-page-not-found>